import { roundTo } from "../utils/mathUtils";
import { divCol, yearCol } from "./leaderboards/helpers";

const BASE_STATE_ORDER_MAP = {
  "NNN": 1,
  "YNN": 2,
  "NYN": 3,
  "NNY": 4,
  "YYN": 5,
  "YNY": 6,
  "NYY": 7,
  "YYY": 8,
};

const BASES_LABEL_MAP = {
  "NNN": "Bases empty",
  "YNN": "Runner on 1st",
  "NYN": "Runner on 2nd",
  "NNY": "Runner on 3rd",
  "YYN": "1st and 2nd",
  "YNY": "1st and 3rd",
  "NYY": "2nd and 3rd",
  "YYY": "Bases loaded",
};

const formatBases = (bases) => {
  if (!bases) return "—";
  const normalized = bases.toUpperCase().trim();
  return BASES_LABEL_MAP[normalized] || bases;
};

export const getBaseStateOrder = (bases) => {
  if (!bases) return 0;
  const normalized = bases.toUpperCase().trim();
  return BASE_STATE_ORDER_MAP[normalized] || 999;
};

export function getExpectedRunsColumns() {
  return [
    yearCol(),
    divCol(),
    {
      name: "Bases",
      selector: (row) => row.bases,
      sortable: true,
      width: "10rem",
      cell: (row) => formatBases(row.bases),
      sortFunction: (rowA, rowB) => {
        return getBaseStateOrder(rowA.bases) - getBaseStateOrder(rowB.bases);
      },
    },
    {
      name: "ERV 0 Outs",
      selector: (row) => roundTo(row.erv_0, 3),
      sortable: true,
      width: "8rem",
    },
    {
      name: "ERV 1 Out",
      selector: (row) => roundTo(row.erv_1, 3),
      sortable: true,
      width: "8rem",
    },
    {
      name: "ERV 2 Outs",
      selector: (row) => roundTo(row.erv_2, 3),
      sortable: true,
      width: "8rem",
    },
    {
      name: "Prob 0 Outs",
      selector: (row) => roundTo(row.prob_0, 3),
      sortable: true,
      width: "8rem",
    },
    {
      name: "Prob 1 Out",
      selector: (row) => roundTo(row.prob_1, 3),
      sortable: true,
      width: "8rem",
    },
    {
      name: "Prob 2 Outs",
      selector: (row) => roundTo(row.prob_2, 3),
      sortable: true,
      width: "8rem",
    },
  ];
}
